import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCTABar from "./MobileCTABar";
import { trackPageview, attachConversionHeaders } from "../lib/analytics";

export default function Layout() {
  const location = useLocation();
  React.useEffect(() => { attachConversionHeaders(); }, []);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    trackPageview(location.pathname);
  }, [location.pathname]);
  return (
    <div className="App min-h-screen flex flex-col bg-bone">
      <Navbar />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
}
